const br = {

    efficiency: {
        item1: "Solução Tudo-em-Um",
        item2: "Processamento Ágil",
        item3: "Suporte 24/7"
    },

    menu: {
        solution: 'Soluções',
        solution1: 'Aquisição global transfronteiriça',
        solution2: 'Plataforma de Gerenciamento de Contas de Comerciante',
        solution3: 'Pagamentos globais transfronteiriços',
        solution4: 'Acesso multi-cenário',
        aboutus: 'Sobre',
        privacypolicy: 'Política de Privacidade',
        AmlPolicy: 'Política AML/KYC',
        technicalaccess: 'Documentação',
        technicalaccess1: 'Documentos de Cobrança',
        technicalaccess2: 'Documentos de Desembolso',
        technicalaccess3: 'Documentos de Assinatura',
        technicalaccess4: 'FAQs',

        pricinginformation: 'Informações de Preços',
        contactus: 'Contato',
        contactusmessage: 'Entre em contato para obter uma conta gratuita',
        companyintroduction: 'Introdução da Empresa',
        knowlegeHub: 'Centro de Conhecimento',
        termofUse: 'Termos de Uso',
        companyMoments: 'Notícias da Empresa',
    },
    globalCollection: 'Cobrança Global',
    solutions: {
        title1: 'Transações sem fronteiras',
        content1: 'Realize integração única com Unionwallex e aceite pagamentos globais facilmente.',

        title2:'Integração simplificada para pagamentos locais, aumentando seus lucros.',
        cardtitle1: 'Cobertura: 100+ países, 10+ idiomas e moedas',
        cardcontent1: 'Unionwallex possui alta penetração em mercados emergentes, oferecendo serviços de pagamento mais localizados para seus usuários',

        cardtitle2: 'Suporte a 100+ principais métodos de pagamento globais',
        cardcontent2: 'Cobre os métodos de pagamento mais populares localmente, como cartões de crédito, carteiras eletrônicas, filiais físicas, operadoras de telecomunicações, etc., resolvendo múltiplos mercados e canais de uma vez.',

        cardtitle3: 'Fornece dados de transação multidimensionais',
        cardcontent3: 'Oferece funções de consulta de pedidos em tempo real, reembolsos, visão geral de dados para melhor compreensão do comportamento transacional e resolução eficaz de reclamações.',

        cardtitle4: 'Estratégias flexíveis de gestão de fundos',
        cardcontent4: 'Oferece múltiplos ciclos de liquidação e soluções para alocação flexível de fundos, resolvendo problemas de fluxo de caixa.',
    },
    globalcrossborderpay: {
        title1: 'Pagamentos transfronteiriços simplificados',
        content1: 'Envie pagamentos para contas locais de usuários e parceiros.',

        title2: 'Serviço de pagamento em lote rápido e conveniente.',
        cardtitle1: 'Métodos de pagamento locais populares',
        cardcontent1: 'Métodos como carteiras digitais e transferências bancárias disponíveis.',

        cardtitle2: 'Custos menores e entrega mais rápida',
        cardcontent2: 'Desembolsos sem integração, operações em lote e transferências instantâneas.',

        cardtitle3: 'Micropagamentos Eficazes',
        cardcontent3: 'Taxa de sucesso de até 98% para pagamentos pequenos e simultâneos.',

        cardtitle4: 'Serviços de valor agregado flexíveis',

        title3: 'Planos de integração variados e custos operacionais minimizados',
        cardtitl5: 'Cenário 1: Sem integração - disponível após registro da conta',
        cardcontent5: 'Realize pagamentos em lote via Painel do Comerciante sem desenvolvimento.',

        cardtitl6: 'Cenário 2: Integração via API - concluída em um dia',
        cardcontent6: 'Pagamentos automatizados via API após integração.',

        title4: 'Soluções de desembolso local da Unionwallex em múltiplos países',
        HongKong: 'Hong Kong',
        Brazil: 'Brasil',
        Mexico: 'México',
        Peru: 'Peru',
        India: 'Índia',
        Philippines: 'Filipinas',

        title5: 'Processo de desembolso\n',
        subtitle51: 'Coletar informações da conta\n',
        subtitle52: 'Enviar solicitação de desembolso\n',
        subtitle53: 'Detecção de risco\n',
        subtitle54: 'Transferência concluída\n',
    },
    showtitle: 'Aceite pagamentos globalmente com integração gratuita',
    showcontent: 'Com profundo entendimento de hábitos de pagamento globais, Unionwallex suporta 100+ métodos e 10+ idiomas, cobrindo 10+ regiões.',
    numcontent1: 'Regiões',
    numcontent2: 'Idiomas',
    numcontent3: 'Métodos de Pagamento',
    learnmore: 'SAIBA MAIS',

    merchantAccountManagePlatform: {
        title1: 'Plataforma de Gerenciamento de Contas',
        content1: 'Funções como pesquisa de pedidos, análise de dados, reembolsos e liquidação para redução de custos operacionais.',

        title2: 'Análise multidimensional para aumento de receita',
        content2: 'Exportação de dados e ajuste de estratégias de vendas.',

        title3: 'Resolução rápida de reclamações',
        cardtitle1: 'Processamento autônomo de reclamações',
        cardcontent1: 'Disponível globalmente em 30+ fusos horários. Permite consulta multifiltro de pedidos para localização eficaz e atendimento ágil ao cliente.',
        cardtitle2: 'Serviço personalizado de gestor de conta',
        cardcontent2: 'Serviços de conta gratuitos fornecidos pelas equipes de Gestores de Conta, Produto e Tecnologia da Unionwallex.',

        title4: 'Estratégias flexíveis para gestão de fluxo de caixa',
        cardtitle41: 'Conciliação autônoma',
        cardcontent41: 'Exportação de dados financeiros via SFTP ou Painel.',

        cardtitle42: 'Gestão de Fundos Financeiros',
        cardcontent42: 'Verificação de saldo e alocação flexível de fundos.',
        cardtitle43: 'Liquidação autônoma',
        cardcontent43: 'Saque conforme necessidade via auto-atendimento.',

        title5: 'Gestão de autorizações de acesso',
        cardtitle51: 'Processo de aprovação\n',
        cardcontent51: 'Personalize os procedimentos internos de aprovação de desembolsos e reembolsos conforme seus fluxos operacionais.',

        cardtitle52: "Recurso de subcontas\n",
        cardcontent52: 'Definir níveis hierárquicos de autorização e divulgar informações pertinentes conforme a função do colaborador, assegurando a segurança de dados em conformidade com a LGPD.',
    },

    multiScenarioIntegration: {
        title1: 'Integração multi-cenário',
        content1: 'Adaptação a dispositivos móveis, PCs e tablets para diversos cenários.',

        title2: 'Atendimento a múltiplas necessidades de pagamento\n',
        content2: 'Disponível para mobile, PC e tablets.',

        cardtitle1: 'Pagamento in-app',
        cardcontent1: 'Redução de redirecionamentos para melhor experiência.',
        cardtitle2: 'Pagamento web',
        cardcontent2: 'Funcionamento perfeito em navegadores móveis e PCs.',
        cardtitle3: 'Pagamento recorrente',
        cardcontent3: 'Débitos recorrentes após autorização do usuário.',

        title3: 'Métodos populares de integração',
        cardtitle31: 'Integração via API\n',
        cardcontent31: '1. Disponível para mobile (Android & iOS) e web',
        cardcontent311: '2. Escopo amplo para integração livre',

        cardtitle32: 'Integração via SDK\n',
        cardcontent32: '1. Aplicável para apps Android',
        cardcontent321: '2. Integração rápida com pacote compacto',
    },

    about: {
        title1: 'Sobre',
        content1: 'Unionwallex fornece soluções profissionais de pagamento global. Com experiência em mercados emergentes, oferecemos segurança e conformidade para empresas internacionais.',

        emailDesc: "Contate-nos por e-mail para respostas detalhadas!",
        phoneDesc: "Ligue para suporte profissional direto!",
        telegramDesc: "Contate via Telegram para respostas rápidas!",
        telegramBtn: "Conectar",

        cardtitle: 'Licença de Brasileira',
        linkbtn: 'Ver licença',

        title2: 'Qualificação da Empresa',
        content2: 'A Unionwallex possui licenças emitidas por agências reguladoras governamentais em vários mercados-chave, e sempre seguimos as normas de conformidade e a aplicação de regulamentos legais para garantir a segurança dos fundos dos clientes.',

        title3: 'Empresas Globais',
        content3: 'Escritórios locais em Hong Kong, Brasil, the Emirates, México, Peru, Índia, Thailand, e Filipinas.',
        hongkongCompanayLisense: 'Licença de Hong Kong',
        uaeCompanyLicense: 'Licença de The Emirates',
        thailandCompanyLicense:'Licença de Thailand'
    },

    contactobj: {
        contactintro: 'Entre em contato para mais informações sobre pagamento',
        title: 'Bem-vindo(a) a deixar uma mensagem',
        target: 'Entraremos em contato o mais breve possível',
        tab1: 'Parceria comercial',
        tab2: 'Feedback do usuário',
        applicationanme: 'Nome da aplicação',
        buytime: 'Data da compra',
        userid: 'ID do usuário',
        orderid: 'Número do pedido',
        paytype: 'Método de pagamento',
        currencyandamount: 'Moeda da compra',
        currencyandamount2: 'Valor da compra',
        paymentscreenshot: 'Comprovante de pagamento',
        commentplaceholder: 'Por favor, descreva sua dúvida e entraremos em contato em breve',

        upload: 'Upload',
        uploadlimit: 'O arquivo deve ter menos de 20MB',
        uploadmessage: 'Forneça comprovantes de pagamento ou débito para agilizar a solução',
        selectdate: 'Selecionar data',
    },

    message: {
        name: 'Nome completo',
        email: 'E-mail',
        phone: 'Telefone',
        companyname: 'Nome da empresa',
        link: 'Website da empresa / Link do produto',
        comment: 'Mensagem',
        commentplaceholder: "Gostaríamos de saber mais sobre seu negócio e como podemos colaborar.",
        agreemessage: 'Você concorda que processaremos suas informações pessoais de acordo com a',
        privacy: 'Política de privacidade da Unionwallex'
    },
    userfeedback: 'Feedback do cliente',
    sendmessage: 'Enviar',


    nav: {
        solutions: 'Negócios',
        resources: 'Centro de recursos',
        about: 'Empresa',
        help: 'Suporte'
    },


    banner: {
        title: "Serviços ao seu redor!",
        title2: "Solução unificada para pagamentos globais!",
        desc: "A UnionWallex dedica-se a fornecer serviços de pagamento transfronteiriço convenientes e profissionais para usuários de e-commerce, criando um sistema abrangente baseado em cenários de pagamento global, ajudando empresas chinesas a cobrir toda a cadeia produtiva internacional.",
        more: "saiba mais"
    },

    pic_desc1: "Processamento rápido",
    pic_desc2: "Serviço integrado",
    pic_desc3: "Suporte 24/7",

    button: {
        login: 'Entrar',
        register: 'Cadastrar'
    },

    language: {
        selector: 'EN-Inglês'
    },

    homepage: {
        title: 'Acesso Eficiente às Redes de Pagamento Locais Globais',
        description: 'A rede de pagamentos locais da UnionWallex oferece soluções mais rápidas, econômicas e transparentes que os bancos tradicionais.',

        services: {
            item1: 'Cobertura global integrada, alcance consumidores em múltiplos países com conversão otimizada, quebrando barreiras de pagamento internacional',
            item2: 'Otimização inteligente de taxas de sucesso, com motor de risco em tempo real e conformidade local, garantindo segurança e ciclos de pagamento reduzidos',
            item3: 'Gestão automatizada de liquidações transfronteiriças, reduzindo custos operacionais e aumentando a transparência financeira'
        },

        stats: {
            countriesBankAccounts: {
                value: '60+',
                unit: '',
                description: 'países/regiões para abertura de contas bancárias locais'
            },
            totalTransactions: {
                value: '100 bilhões',
                unit: '',
                description: 'em volume transacional anual processado'
            },
            localPayments: {
                value: '120+',
                unit: '',
                description: 'países/regiões para pagamentos locais'
            },
            acquiringCountries: {
                value: '180+',
                unit: '',
                description: 'países/regiões para aquisição de comerciantes'
            }
        }
    },

    crossBorder: {
        title: "Serviços de Valor Agregado Transfronteiriço",
        desc: "Cobertura completa de serviços para impulsionar seu negócio global",
        services: {
            service1: {
                title: "Recebimento Global Facilitado, Integração Automatizada sem Custos",
                content: "Suporte a comércio eletrônico, aplicativos, jogos, curtas-metragens, transmissões ao vivo, produtos digitais e outros setores, com recebimento de pagamentos por meio de gateway de pagamento, transferência bancária​​, ​​carteira eletrônica (e-wallet), entre outros, abrangendo múltiplos países e regiões e diversos idiomas locais, ajudando você a expandir facilmente o mercado global."
            },
            service2: {
                title: "Pagamentos Transfronteiriços, Liquidação Instantânea",
                content: "Ajudar os clientes a pagar salários e dividendos a funcionários locais, criadores, sindicatos e MCNs por meio de pagamentos bancários locais e pagamentos via carteira digital em moedas locais."
            }
        },

        security: {
            title: "Operações Seguras e Conformes",
            items: {
                fundSecurity: {
                    title: "Segurança de Fundos",
                    content: "Colaboramos com as principais instituições financeiras globais para gerenciar seus fundos adequadamente, seguindo rigorosamente regulamentações locais para garantir liquidez e segurança."
                },
                encryption: {
                    title: "Tecnologia de Criptografia",
                    content: "Adotamos criptografia SSL, armazenamento criptografado de dados e outras tecnologias para proteger informações dos clientes durante pagamentos, prevenindo vazamentos e ataques cibernéticos."
                },
                riskMonitor: {
                    title: "Monitoramento e Alerta de Riscos",
                    content: "Detecta comportamentos anormais e fatores de risco em transações em tempo real, emitindo alertas preventivos e implementando medidas de contenção conforme protocolos de segurança."
                },
                compliance: {
                    title: "Conformidade Regulatória",
                    content: "UnionWallex cumpre rigorosamente regulamentações e normas do setor em todos os mercados onde atuamos, incluindo LGPD e padrões PCI-DSS."
                },
                standards: {
                    title: "Padrões Rigorosos",
                    content: "Alinhados às mais altas normas internacionais de segurança (como ISO 27001) e requisitos regulatórios locais em cada jurisdição."
                }
            }
        },

        efficiency: {
            title: "Eficiência Operacional",
            content: "Plataforma unificada para gestão de cobranças e liquidações com automação completa",
            content1: "Arquitetura técnica avançada para processamento acelerado de transações",
            content2: "Suporte técnico 24 horas por dia via canais online"
        },

        customization: {
            title: "Soluções Personalizadas",
            solutions: {
                enterprise: "Soluções Corporativas",
                enterprise_desc: "Integração global de métodos de pagamento com otimização de câmbio e compliance",
                personal: "Suporte Dedicado",
                personal_desc: "Consultoria 1:1 para liquidação multi-moeda e gestão de riscos",
                flexible: "Planos Flexíveis",
                flexible_desc: "Adaptação inteligente a mais de 100 métodos de pagamento locais"
            }
        }
    },

    faq: {
        title: "Perguntas Frequentes",
        questions: {
            title1: "Por que as taxas de câmbio variam para transações no mesmo dia?",
            content1: "Estamos comprometidos em fornecer o melhor serviço de taxas de câmbio. Para alcançar isso, utilizamos diretamente as taxas de liquidação recebidas dos fornecedores de pagamento (como organizações de cartões ou canais de pagamento locais) para converter os pagamentos recebidos em diferentes moedas em sua moeda de liquidação padrão. Portanto, você pode observar que diferentes transações no mesmo dia usam taxas de câmbio diferentes. Isso ocorre porque diferentes fornecedores de pagamento usam suas próprias taxas de câmbio, e o horário limite de atualização diário para cada fornecedor de pagamento pode ser diferente do seu ciclo de liquidação.",
            title2: "Transferências internacionais estão sujeitas a impostos?",
            content2: "O BRL será convertido para USD na taxa de câmbio em tempo real e debitado da sua carteira. Exemplo 2: Você insere 1.000 USD no campo 'Você Envia' na página de pagamento e seleciona BRL como a moeda recebida pelo destinatário. Como a taxa de imposto sobre transações financeiras no Brasil é de 0,38%, o valor do imposto é de 3,8 USD (1.000 * 0,38%)."
        }
    },

    compliance: {
        title: "Segurança & Conformidade",
        sections: {
            title1: "Conformidade Regulatória",
            content1: "Para garantir a segurança dos fundos dos clientes, a UnionWallex adotou regulamentos globais da indústria com uma atitude proativa desde seu início. Criamos uma equipe internacional de conformidade de alto padrão, seguindo rigorosamente as convenções internacionais de combate à lavagem de dinheiro e as leis e regulamentos relevantes das autoridades reguladoras, além de tomar medidas rigorosas para cumprir nossas responsabilidades.",
            title2: "Conformidade Financeira",
            content2: "A UnionWallex emprega uma equipe profissional de um grande escritório de contabilidade internacional para realizar auditorias internas rigorosas, garantindo o cumprimento das normas. Além disso, estabelecemos um sistema maduro e completo de conformidade contra lavagem de dinheiro e financiamento do terrorismo, realizando verificação de identidade para os clientes, a fim de garantir a segurança dos fundos e transações financeiras dos clientes.",
            title3: "Conformidade Procedimental",
            content3: "As soluções comerciais da UnionWallex passaram por vários check-ups de conformidade de bancos comerciais cooperativos, desde o exterior até a China. Os fundos internacionais dos clientes da UnionWallex são armazenados em contas de reserva de bancos internacionais de primeira linha, protegidos tanto pelas autoridades reguladoras financeiras quanto pelos bancos de vários países; os fundos internos são 100% administrados por instituições de pagamento de terceiros licenciadas e bancos domésticos. Todas as operações de fundos são realizadas estritamente de acordo com as instruções dos clientes."
        }
    },

    privacy: {
        title: "Proteção de Privacidade",
        content: "A UnionWallex possui uma equipe de tecnologia e riscos formada por elites financeiras e de TI, com confiança e capacidade suficientes para proteger a privacidade do usuário. Além disso, a UnionWallex estabeleceu um sistema de transações seguro com padrões de alto nível da indústria, testado e avaliado independentemente por instituições de terceiros autorizadas, garantindo rigorosamente a segurança das informações e fundos dos usuários. Sem sua autorização, a UnionWallex jamais divul将ar suas informações a terceiros."
    },

    footer: {
        account_desc: "Contate-nos para obter uma conta gratuita",
        connect_desc: "Fale Conosco",
        products: "Produtos",
        products_global_acquiring: "Adquirente Global",
        products_global_payments: "Pagamentos Globais",
        products_global_getPay: "Recebimento Internacional",
        products_risk_control_management: "Gestão de Riscos",
        products_foreign_exchange_management: "Câmbio Internacional",
        products_fund_management: "Gestão de Fundos",
        solutions: "Soluções",
        solutions_acquiring: "Adquirente transfronteiriço",
        solutions_payments: "Pagamentos internacionais",
        solutions_platform: "Plataforma de Gestão de Contas",
        solutions_access: "Integração multi-cenários",
        aboutUs: "Sobre Nós",
        aboutUs_company: "Empresa",
        aboutUs_news: "Notícias",
        aboutUs_terms: "Termos de Uso",
        aboutUs_join: "Carreiras",
        resources: "Centro de Recursos",
        resources_deposit: "Documentos de Cobrança",
        resources_withdraw: "Documentos de Pagamento",
        resources_subscription: "Documentos de Assinatura",
        copyright: "Todos os direitos reservados"
    },

    crossBorderAcquiring: {
        overview: {
            main_title: "Documentação de Adquirente Transfronteiriço",
            title: "1. Visão Geral",
            purpose: {
                title: "1.1 Objetivo",
                content: "Fornecer diretrizes técnicas e requisitos de compliance para integração de adquirente internacional, garantindo eficiência e segurança operacional"
            },
            scope: {
                title: "1.2 Escopo",
                content: "Aplicável a todos os parceiros que realizam transações internacionais através da plataforma"
            }
        },
        businessProcess: {
            title: "2. Fluxos Operacionais",
            paymentProcess: {
                title: "2.1 Fluxo de Pagamento",
                steps: {
                    step1: "O usuário realiza o pedido e seleciona o método de pagamento (ex: cartão, carteira digital)",
                    step2: "A solicitação é enviada ao gateway de pagamento",
                    step3: "Verificação de riscos, conversão cambial (se aplicável) e roteamento para canais de pagamento",
                    step4: "Retorno do resultado para o sistema do merchant"
                }
            },
            settlementProcess: {
                title: "2.2 Liquidação",
                steps: {
                    step1: "Fundos liquidados na conta designada (incluindo multi-moedas)",
                    step2: "Ciclo de liquidação conforme contrato (ex: T+1)",
                    step3: "Emissão de relatórios de liquidação"
                }
            }
        },
        technicalIntegration: {
            title: "3. Integração Técnica",
            api: {
                title: "3.1 APIs Principais",
                paymentRequest: "API de Solicitação de Pagamento: Inicia transações com dados do pedido",
                paymentNotification: "API de Notificação: Retorno assíncrono do status",
                query: "API de Consulta: Verificação do status da transação"
            },
            dataFormat: {
                title: "3.2 Formato de Dados",
                content: "JSON/XML para requisições e respostas"
            },
            security: {
                title: "3.3 Segurança",
                https: "HTTPS com TLS 1.2+",
                signature: "Assinatura digital SHA256/RSA"
            }
        },
        compliance: {
            title: "4. Conformidade",
            aml: {
                title: "4.1 AML/KYC",
                content: "Verificação de identidade e monitoramento de transações suspeitas"
            },
            dataProtection: {
                title: "4.2 LGPD/PCI DSS",
                content: "Proteção de dados sensíveis conforme regulamentações brasileiras e internacionais"
            },
            forex: {
                title: "4.3 Controles Cambiais",
                content: "Conformidade com regulamentações do Banco Central do Brasil (Circular 3.691)"
            }
        },
        riskManagement: {
            title: "5. Gestão de Riscos",
            measures: {
                title: "5.1 Medidas",
                monitoring: "Monitoramento em tempo real com análise comportamental",
                secure3D: "Autenticação 3D Secure 2.0"
            },
            chargeback: {
                title: "5.2 Contestções",
                process: "Processo de chargeback com evidências digitais",
                evidence: "Armazenamento obrigatório por 18 meses"
            }
        },
        feesAndSettlement: {
            title: "6. Custos",
            feeStructure: {
                title: "6.1 Estrutura",
                transactionFee: "Taxa de processamento: 1.5% + R$0.50",
                exchangeRateMargin: "Spread cambial: 1.2% sobre PTAX",
                settlementFee: "Custos SWIFT/SPB: R$15 por remessa"
            },
            settlementCycle: {
                title: "6.2 Periodicidade",
                content: "Liquidação em D+1 para BRL, D+3 para outras moedas"
            }
        },
        supportAndMaintenance: {
            title: "7. Suporte",
            technicalSupport: {
                title: "7.1 Técnico",
                content: "Plantão 24/7 via chat e telefone"
            },
            updates: {
                title: "7.2 Atualizações",
                content: "Versões API com backward compatibility"
            }
        }
    },

    crossBorderPayment: {
        overview: {
            main_title: "Documentação de Pagamento Internacional",
            title: "1. Introdução",
            purpose: {
                title: "1.1 Finalidade",
                content: "Orientação técnica para integração de pagamentos globais com segurança e compliance"
            },
            scope: {
                title: "1.2 Aplicabilidade",
                content: "Usuários finais e comerciantes realizando transações internacionais"
            }
        },
        paymentProcess: {
            title: "2. Fluxos",
            userPaymentProcess: {
                title: "2.1 Pagamento",
                step1: "Seleção de produtos e checkout",
                step2: "Escolha do meio de pagamento",
                step3: "Inserção dos dados de pagamento",
                step4: "Confirmação do valor em moeda estrangeira",
                step5: "Processamento via gateway"
            },
            paymentResultNotification: {
                title: "2.2 Notificações",
                step1: "Confirmação instantânea ao usuário",
                step2: "Webhook para atualização do sistema"
            }
        },
        technicalIntegration: {
            title: "3. Integração",
            api: {
                title: "3.1 Endpoints",
                paymentRequest: "API de Iniciação: Parâmetros de valor, moeda e destinatário",
                paymentNotification: "Callback de status",
                query: "Consulta transacional"
            },
            dataFormat: {
                title: "3.2 Especificações",
                content: "Estrutura JSON com encoding UTF-8"
            },
            security: {
                title: "3.3 Criptografia",
                https: "Conexão segura com TLS",
                signature: "HMAC-SHA256 para autenticação"
            }
        },
        compliance: {
            title: "4. Regulatórios",
            aml: {
                title: "4.1 Prevenção à Fraude",
                content: "Validação de CPF/CNPJ e origem dos recursos"
            },
            dataProtection: {
                title: "4.2 Privacidade",
                content: "Certificação PCI DSS nível 1"
            },
            forex: {
                title: "4.3 Câmbio",
                content: "Conformidade com Instrução Normativa RFB 1.634"
            }
        },
        feesAndExchangeRates: {
            title: "5. Custos e Câmbio",
            feeStructure: {
                title: "5.1 Tarifas",
                transactionFee: "Taxa por transação: 2% + IOF",
                exchangeRateMargin: "Spread: 1% sobre cotação BCB",
                bankFee: "Custos correspondentes bancários"
            },
            exchangeRate: {
                title: "5.2 Cotações",
                realTime: "Taxa spot atualizada a cada 15 segundos",
                locked: "Bloqueio cambial por 48 horas"
            }
        },
        riskManagement: {
            title: "6. Riscos",
            measures: {
                title: "6.1 Controles",
                monitoring: "Detecção de padrões anômalos via machine learning",
                secure3D: "Autenticação reforçada para cartões"
            },
            refunds: {
                title: "6.2 Reembolsos",
                process: "Devolução via mesma via de pagamento",
                dispute: "Solução de disputas em até 72h"
            }
        },
        supportAndMaintenance: {
            title: "7. Suporte Técnico",
            technicalSupport: {
                title: "7.1 Especializado",
                content: "Documentação técnica detalhada com exemplos em Postman"
            },
            updates: {
                title: "7.2 Atualizações",
                content: "Versões API publicadas via changelog"
            }
        }
    },

    crossBorderPaymentSub: {
        overview: {
            main_title: "Documentação de Assinatura Transfronteiriça",
            title: "1. Visão Geral",
            purpose: {
                title: "1.1 Objetivo",
                content: "Fornecer diretrizes técnicas para serviços de cobrança recorrente internacional, garantindo conformidade regulatória e segurança operacional"
            },
            scope: {
                title: "1.2 Escopo",
                content: "Aplicável a todos os usuários e parceiros que utilizam assinaturas pagas via plataforma"
            }
        },
        subscriptionModel: {
            title: "2. Modelos de Assinatura",
            types: {
                title: "2.1 Tipos",
                fixedCycle: "Cobrança Fixa: Débito automático em ciclos pré-definidos (ex: mensal/ano)",
                usageBased: "Uso Variável: Liquidação baseada no consumo real (ex: serviços cloud)"
            },
            lifecycle: {
                title: "2.2 Ciclo de Vida",
                create: "Criação: Seleção do plano e primeiro pagamento",
                renew: "Renovação: Débito automático no vencimento",
                cancel: "Cancelamento: Interrupção a qualquer momento",
                expire: "Expiração: Status após falha de pagamento"
            }
        },
        paymentProcess: {
            title: "3. Fluxo de Pagamento",
            firstPayment: {
                title: "3.1 Pagamento Inicial",
                content: "Cartões, carteiras digitais e TED como métodos de pagamento"
            },
            autoRenewal: {
                title: "3.2 Renovação Automática",
                content: "Tentativa automática de débito no vencimento do ciclo"
            },
            paymentFailure: {
                title: "3.3 Tratamento de Falhas",
                content: "3 tentativas de retentativa antes de marcar como expirado"
            }
        },
        technicalIntegration: {
            title: "4. Integração Técnica",
            api: {
                title: "4.1 APIs Principais",
                create: "API de Criação: Define ciclo, valor e moeda da assinatura",
                notify: "Webhook de Notificação: Status de cada pagamento",
                cancel: "API de Cancelamento: Encerra assinaturas",
                query: "API de Consulta: Histórico e status atual"
            },
            dataFormat: {
                title: "4.2 Formato de Dados",
                content: "Estrutura JSON com codificação UTF-8"
            },
            security: {
                title: "4.3 Segurança",
                https: "HTTPS com TLS 1.3",
                signature: "Assinatura HMAC-SHA256"
            }
        },
        compliance: {
            title: "5. Conformidade",
            aml: {
                title: "5.1 AML/KYC",
                content: "Validação de documentos via Receita Federal"
            },
            dataProtection: {
                title: "5.2 LGPD",
                content: "Certificação PCI DSS nível 1 para dados sensíveis"
            },
            forex: {
                title: "5.3 Controles Cambiais",
                content: "Conformidade com a Circular BCB 3.691"
            }
        },
        feesAndRates: {
            title: "6. Custos",
            feeStructure: {
                title: "6.1 Estrutura Tarifária",
                transactionFee: "Taxa de processamento: 2.5% + IOF",
                exchangeRateMargin: "Spread: 1% sobre PTAX",
                bankFee: "Custos SWIFT: R$20 por operação"
            },
            exchangeRate: {
                title: "6.2 Câmbio",
                realTime: "Taxa spot atualizada em tempo real",
                locked: "Bloqueio cambial por 24h"
            }
        },
        riskManagement: {
            title: "7. Gestão de Riscos",
            measures: {
                title: "7.1 Controles",
                monitoring: "Monitoramento de transações via machine learning",
                secure3D: "3D Secure 2.0 para autenticação"
            },
            refunds: {
                title: "7.2 Reembolsos",
                process: "Devolução integral via método original",
                dispute: "Resolução de disputas em 5 dias úteis"
            }
        },
        supportAndMaintenance: {
            title: "8. Suporte",
            technicalSupport: {
                title: "8.1 Técnico",
                content: "Plantão 24/7 via telefone e chat"
            },
            updates: {
                title: "8.2 Atualizações",
                content: "Versões API com backward compatibility"
            }
        }
    },

    login: {
        title: 'Acesso',
        email: 'E-mail',
        password: 'Senha',
        submit: 'Entrar',
        reset: 'Limpar',
        emailRequired: 'Insira seu e-mail',
        emailInvalid: 'E-mail inválido',
        passwordRequired: 'Insira sua senha',
        success: 'Login realizado',
    },
    register: {
        title: 'Cadastro',
        email: 'E-mail',
        password: 'Senha',
        confirmPassword: 'Confirme a senha',
        submit: 'Registrar',
        reset: 'Limpar',
        emailRequired: 'Campo obrigatório',
        emailInvalid: 'Formato inválido',
        passwordRequired: 'Crie uma senha',
        confirmPasswordRequired: 'Confirme sua senha',
        passwordMismatch: 'As senhas não coincidem',
        success: 'Cadastro concluído',
    },

    policyTitle: 'Política de Privacidade',
    introduction: `A Unionwallex, operada pela Unionwallex Limited ("Unionwallex", "nós", "nosso"), atua como agregador de pagamentos facilitando o processamento de transações ("Serviço Unionwallex") para nossos clientes ("merchantes"). Durante este processo, necessitamos de informações pessoais para transações específicas. Esta Política descreve como coletamos, usamos, armazenamos e divulgamos dados pessoais.`,

    infoCollectionTitle: 'Seção 1: Dados Coletados e Finalidades',
    infoCollectionItem1: 'Ao realizar pagamentos através de merchantes que utilizam nosso Serviço',
    infoCollectionItem2: 'Ao consultar sobre nossos serviços ou interagir em nosso website',
    infoCollectionItem3: 'Em comunicações telefônicas, eletrônicas ou por outros meios digitais',
    infoCollectionItem4: 'Em eventos corporativos ou inscrições para recebimento de materiais',
    infoCollectionItem5: 'Durante o cadastro de merchantes e interações relacionadas ao serviço',
    infoCollectionItem6: 'Ao prestar serviços conosco ou manifestar interesse em fazê-lo. Podemos obter dados de terceiros conforme necessário, incluindo:<br>• Fontes públicas<br>• Parceiros comerciais<br>• Sistemas antifraude[3](&#64;ref)',

    infoSharingTitle: 'Seção 2: Compartilhamento de Dados',
    infoSharingItem1: 'Merchants: Compartilhamos dados transacionais necessários para conclusão de operações, conforme autorizado por lei[4](&#64;ref)',
    infoSharingItem2: 'Instituições financeiras: Dados necessários para processamento de pagamentos através de provedores licenciados',
    infoSharingItem3: 'Agências de prevenção a fraudes: Dados para verificações AML/KYC e redução de riscos',
    infoSharingItem4: 'Autoridades competentes: Cumprimento de obrigações legais incluindo FATF e regulamentações locais',
    infoSharingItem5: 'Parceiros tecnológicos: Provedores de armazenamento em nuvem e processamento de pagamentos',
    infoSharingItem6: 'Sucessores comerciais: Em casos de fusão ou aquisição',
    infoSharingItem7: 'Afiliadas: Compartilhamento para prestação integrada de serviços',

    dataRetentionTitle: 'Seção 3: Retenção de Dados',
    dataRetentionContent: 'Conservamos dados pelo período necessário para:<br>• Cumprimento de obrigações legais (ex: AML/KYC)<br>• Exercício de direitos legais<br>• Finalidades comerciais legítimas[2](&#64;ref)',

    userRightsTitle: 'Seção 4: Direitos do Titular',
    userRightsDesc: 'Conforme a LGPD (Lei 13.709/2018), você possui direito a:',
    userRightsItem1: 'Acesso e confirmação de existência de tratamento',
    userRightsItem2: 'Retificação ou exclusão de dados inexatos',
    userRightsItem3: 'Anonimização ou bloqueio de dados desnecessários',
    userRightsItem4: 'Portabilidade de dados para outro provedor',
    userRightsItem5: 'Revogação de consentimento e reclamação à ANPD',
    userRightsItemDesc: 'Observação: Alguns direitos podem ser limitados por obrigações regulatórias. Contate-nos para exercê-los.',

    securityTitle: 'Seção 5: Segurança',
    securityContent: 'Implementamos:<br>• Criptografia SSL/TLS<br>• Controles de acesso biométricos<br>• Monitoramento 24/7 contra intrusões<br>Dados sensíveis como senhas são armazenados com hash irreversível[4](&#64;ref)',

    contactTitle: 'Seção 6: Contato',
    contactContent: 'Dúvidas ou exercício de direitos:<br>E-mail: service&#64;unionwallex.com<br>Horário: 09h-18h (Brasília)',

    changeTitle: 'Seção 7: Atualizações',
    changeContent: 'Alterações serão comunicadas por:<br>• Notificação no site<br>• E-mail para usuários cadastrados<br>Data da última revisão: 08/04/2025',

    supplementTitle: 'Seção 8: Disposições Específicas - Brasil',
// 巴西条款
    brazilContent: `
    <strong>1. Brasil</strong><br>
    A Lei Geral de Proteção de Dados (Lei nº 13.709/2018, "LGPD") estabelece direitos adicionais para usuários no Brasil. Além das disposições gerais desta Política de Privacidade, aplicam-se as seguintes regras específicas:<br>
    <u>Dados de Menores</u>: Não coletamos intencionalmente dados pessoais de menores de 18 anos. Caso identifiquemos tal situação, os dados serão imediatamente excluídos[6,10](&#64;ref). Se você tem menos de 18 anos, não tente utilizar os serviços da Unionwallex ou nos enviar quaisquer dados pessoais.<br>
    <u>Direitos dos Titulares</u>: Conforme o Artigo 18 da LGPD, você possui[2,7,10](&#64;ref):<br>
    • Direito de confirmação da existência de tratamento de dados;<br>
    • Acesso aos seus dados pessoais com detalhes do processamento;<br>
    • Retificação de informações incompletas, imprecisas ou desatualizadas;<br>
    • Anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade com a LGPD;<br>
    • Portabilidade dos seus dados pessoais para outro provedor de serviços;<br>
    • Exclusão de dados processados mediante consentimento;<br>
    • Informações sobre entidades públicas/privadas com quem compartilhamos seus dados;<br>
    • Esclarecimento sobre a possibilidade de recusa de consentimento e suas consequências;<br>
    • Revogação do consentimento e direito de apresentar reclamações perante a ANPD (Autoridade Nacional de Proteção de Dados).
`,

// 印尼条款
    indonesiaContent: `
    <strong>2. Indonésia</strong><br>
    Ao utilizar serviços na República da Indonésia, aplicam-se:<br>
    • <u>Consentimento de Terceiros</u>: Compartilhamento de dados de terceiros exige comprovação de consentimento válido[6](&#64;ref);<br>
    • <u>Restrição de Compartilhamento</u>: Proibido compartilhar dados fora das finalidades contratuais sem autorização expressa;<br>
    • <u>Idioma Oficial</u>: Versão em indonésio prevalece sobre a inglesa em caso de divergências;<br>
    • <u>Menores de 21 anos</u>: Necessário consentimento parental para uso de serviços;<br>
    • <u>Renúncia Legal</u>: Isenção do Artigo 1266 do Código Civil em processos de rescisão[7](&#64;ref).
    `,

// 菲律宾条款
    philippinesContent: `
    <strong>3. Filipinas</strong><br>
    Disposições suplementares incluem:<br>
    • <u>Artigo 1</u>: Obrigatoriedade de consentimento para dados de terceiros;<br>
    • <u>Artigo 3</u>: Especificações técnicas para provedores de serviços;<br>
    • <u>Artigo 5</u>: Continuidade do processamento sob obrigações legais[9,10](&#64;ref).
    `,

// 韩国条款
    southkoreaContent: `
    <strong>4. Coreia do Sul</strong><br>
    Conforme a Lei PIPA (2025):<br>
    • Dados pessoais são armazenados separadamente após cumprimento da finalidade;<br>
    • Métodos de destruição incluem:<br>
      - Exclusão técnica irreversível de arquivos digitais;<br>
      - Fragmentação ou incineração de documentos físicos;<br>
    • Exceções aplicam-se apenas por exigência legal explícita[12,14](&#64;ref).
      `,

    common: {
        plusSign: '+',
        example:'Exemplo'
    }

};


export default br;
